import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CarruselDos({ children }) {
  const [clicked, setClicked] = useState(false);
  const handleMouseDown = () => {
    setClicked(true);
  };
  const handleMouseUp = () => {
    setClicked(false);
  };
  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: width > 1024 ? 4 : width > 600 ? 2 : 1,
    slidesToScroll: width > 1024 ? 4 : width > 600 ? 2 : 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "0px",
        },
      },
    ],
  };
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      className={`w-full overflow-hidden ${clicked ? "cursor-grabbing" : "cursor-grab"} pb-10`}
    >
      <Slider {...settings}>
        {children.map((item, index) => {
          return (
            <div key={index} className="p-2">
              {item}
            </div>
          );
        })}
        {/* <div className="w-full h-48 bg-red-500 flex items-center justify-center">
          <h3>1</h3>
        </div>
        <div className="w-full h-48 bg-red-500">
            2
        </div>
        <div>
          <h3>2</h3>
        </div>
        <div>
          <h3>3</h3>
        </div>
        <div>
          <h3>4</h3>
        </div>
        <div>
          <h3>5</h3>
        </div>
        <div>
          <h3>6</h3>
        </div>
        <div>
          <h3>7</h3>
        </div>
        <div>
          <h3>8</h3>
        </div> */}
      </Slider>
    </div>
  );
}

export default CarruselDos;
